<ion-header collapse="fade">
  <ion-toolbar>
    <ion-title role="heading" aria-level="1" mode="md">
      {{ 'page.settings.title' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="app__description">
    <p>{{ 'page.settings.desc' | translate }}</p>
  </div>
  <div class="app__content settings">
    <div class="settings__main">
      <div
        role="link"
        tabindex="0"
        [routerLink]="['profile']"
        *ngIf="showLogin && !isProjectApp"
        class="ion-activatable"
      >
        {{ 'page.settings.profile' | translate }}
        <ion-ripple-effect></ion-ripple-effect>
      </div>
      <div
        role="link"
        tabindex="0"
        [routerLink]="['permissions']"
        *ngIf="showPermissions"
        class="ion-activatable"
      >
        {{ 'page.settings.permissions' | translate }}
        <ion-ripple-effect></ion-ripple-effect>
      </div>
      <div
        role="link"
        tabindex="0"
        [routerLink]="['preferences']"
        class="ion-activatable"
      >
        {{ 'page.settings.preferences' | translate }}
        <ion-ripple-effect></ion-ripple-effect>
      </div>
      <div
        role="link"
        tabindex="0"
        *ngIf="!isProjectApp"
        [routerLink]="['address', 'list']"
        class="ion-activatable"
      >
        {{ 'page.settings.addresses' | translate }}
        <ion-ripple-effect></ion-ripple-effect>
      </div>
    </div>

    <div class="settings__line"></div>

    <div class="settings__sub">
      <div
        role="link"
        tabindex="0"
        [routerLink]="['/about-app']"
        *ngIf="whiteLabelText"
      >
        {{ 'page.settings.about-app' | translate }}
      </div>
      <div role="link" tabindex="0" (click)="openEula()">
        {{ 'page.settings.eula.desc' | translate }}
      </div>
      <div role="link" tabindex="0" (click)="openPrivacyStatement()">
        {{ 'page.settings.privacy.desc' | translate }}
      </div>
      <div *ngIf="version">
        {{ 'page.settings.version' | translate:{'version': version} }}
      </div>
      <div role="button" tabindex="0" (click)="copy()">
        {{ 'page.settings.device-id' | translate:{'id': truncatedClientSecret}
        }}
      </div>
    </div>
  </div>
</ion-content>
